import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DisplayCentres } from "./pages/DisplayCentres";
import { FAQ } from "./pages/FAQ";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { CollectionPage } from "./pages/CollectionPage";
import { ProductDetail } from "./pages/ProductDetail";
import { ProductCatalogue } from "./pages/ProductCatalogue";
import { ContactUs } from "./pages/ContactUs";
import { HomePage } from "./pages/HomePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <WhatsAppButton />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/display-centres" element={<DisplayCentres />} />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/collection/:slug" element={<CollectionPage />} />
          <Route path="/product/:productSlug" element={<ProductDetail />} />
          <Route path="/product-catalogue" element={<ProductCatalogue />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
